import { h } from './index.js';
import { t as toValue, a as toLabel } from './p-CPuegN2k.js';
import { i as isLavOption } from './p-CdnDatdH.js';

// biome-ignore lint/correctness/noUnusedImports: needed for Stencil
function HiddenHTMLSelect({ disabled, required, name, options, value, ref, multiple, }) {
    return (h("select", { ref: ref, multiple: multiple, hidden: true, disabled: disabled, required: required, name: name }, options?.map((option) => {
        if (!isLavOption(option)) {
            return null;
        }
        const optionValue = toValue(option);
        const optionLabel = toLabel(option);
        const isOptionChecked = (value || []).includes(`${optionValue}`);
        const isOptionDisabled = typeof option === 'object' && option.disabled;
        return (h("option", { key: optionLabel, selected: isOptionChecked, disabled: disabled || isOptionDisabled, value: optionValue }, optionLabel));
    })));
}

export { HiddenHTMLSelect as H };
